/* eslint-disable no-undef */
class ZohoWidgetUtil {

    constructor(userArray) {
        window.ZohoHCAsapSettings = {
            hideLauncherIcon: false,
            ticketsSettings: {
                preFillFields: {
                    "email": {
                        defaultValue: userArray["email"]
                    },
                    "contactId": {
                        defaultValue: userArray["name"]
                    }
                }
            }
        };
    }

    openWidget() {
        ZohoHCAsap.kbCategories();
    }

    hideWidget() {
        ZohoHCAsap.Action("close");
    }

    openTicketWidget() {
        ZohoHCAsap.Action("open", { tab: "TICKETS" });
    }

    openArticleWidget(articleId) {

        let articles = {
            "102129000000855515": "https://help.nordicscreen.com/portal/en/kb/articles/how-to-use-the-golfmore-app",
            "102129000000855644": "https://help.nordicscreen.com/portal/en/kb/articles/google-docs",
            "102129000000855606": "https://help.nordicscreen.com/portal/en/kb/articles/google-slides",
            "102129000000855557": "https://help.nordicscreen.com/portal/en/kb/articles/google-sheets",
            "102129000000985209": "https://help.nordicscreen.com/portal/en/kb/articles/how-to-use-the-word-app",
            "102129000000985251": "https://help.nordicscreen.com/portal/en/kb/articles/how-to-use-the-excel-app",
            "102129000000985297": "https://help.nordicscreen.com/portal/en/kb/articles/how-to-use-the-powerpoint-app",
            "102129000000310335": "https://help.nordicscreen.com/portal/en/kb/articles/how-to-use-web-automation-app"
        };
        if (typeof articles[articleId] != "undefined")
            window.open(articles[articleId], "_blank").focus();
    }

    openGuide() {
        ZohoHCAsap.Action("open", { tab: "KB" });
    }

    openDesk() {
        ZohoHCAsap.kbCategories();
    }
}

window.ZohoWidgetUtil = ZohoWidgetUtil;
